import React from 'react'
import Logo from '../../images/sipora-logo.svg'

const Image = (props) => <img alt="Sipora Logo" src={Logo} {...props} />

export default Image
